import { StyleSheet, Text, View } from 'react-native';
import React, { FC } from 'react';
import { BookingType } from '../types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/redux/store';
import { STYLE_VARS } from '../../../constants/style-vars';
import dayjs from 'dayjs';
import { Button } from '../../../components/Button';
import { FONTS } from '../../../constants';
import { IBookedSport } from '../../../types/sports.types';
import { convertToAmPm } from '../../../services/utils';
import { IBookedEvent } from '../../../types';
import { NavigationService } from '../../../services/navigation';

interface BookingEventProps {
  booking: IBookedEvent;
  onCancelBooking?: (bookingId: string) => void;
  isPast?: boolean;
}

const BookingEvent: FC<BookingEventProps> = ({
  booking,
  onCancelBooking,
  isPast = false,
}) => {
  const { user } = useSelector((redux: RootState) => ({
    user: redux.user.data,
  }));

  return (
    <View style={styles.wrapper}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Text
          style={styles.name}
          numberOfLines={3}
          onPress={() => {
            NavigationService.push<'Root'>('Root', {
              screen: 'MenuTab',
              params: {
                screen: 'EventDetail',
                params: {
                  id: booking.event_id,
                },
              },
            });
          }}
        >
          {booking.event_title || ''}
        </Text>
        <Text
          style={[
            styles.textStyle,
            {
              width: '35%',
              textAlign: 'right',
            },
          ]}
        >
          {convertToAmPm(dayjs(booking.time).format('HH:mm'))}
        </Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <View style={{ width: '65%' }}>
          <Text style={styles.textStyle}>
            {dayjs(booking.time || '').format('DD MMMM YYYY')}
          </Text>
          <Text style={styles.textStyle}>Type: Event</Text>
          <Text style={styles.textStyle}>Status: {booking.status}</Text>
        </View>
        <View>
          {booking.status === 'Pending' && !isPast && (
            <Button
              text="CANCEL"
              style={STYLE_VARS.dangerButton}
              className=""
              onPress={() => {
                if (onCancelBooking) onCancelBooking(booking.id);
              }}
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default BookingEvent;

const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: 20,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 1,
  },
  name: {
    width: '65%',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  textStyle: {
    fontSize: 13,
    lineHeight: 20,
    letterSpacing: 1,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
  },
});
